<template>
  <div>
    <h6>Please wait for up to 10 seconds for the download to commence (depends on your connection speed).</h6>
  </div>
</template>

<script>
  export default {
    mounted () {
      setTimeout(() => this.$emit('close'), 3000)
    }
  }
</script>

<style scoped>

</style>
